import { TopHeader } from '@mkp/layout/models';
import { HeaderBuilder } from '@mkp/shared/util-header-builder';

export const loggedInUserDefaultTopHeader = (isMobile: boolean): TopHeader =>
  new HeaderBuilder()
    .withHeaderBackground('dark')
    .withLefBoxItem('burger_menu')
    .withLefBoxItem('selected_workspace')
    .withOptionalRightBoxItem(!isMobile ? 'lang_menu' : undefined)
    .withRightBoxItem('user_menu')
    .withName(`loggedInUserDefault${isMobile ? 'Mobile' : ''}TopHeader`)
    .build();

export const preAccessPageTopHeader = (isMobile: boolean): TopHeader =>
  new HeaderBuilder()
    .withHeaderBackground('dark')
    .withLefBoxItem('one_logo', { disabled: true })
    .withOptionalRightBoxItem(!isMobile ? 'lang_menu' : undefined)
    .withRightBoxItem('user_menu')
    .withName(`preAccessPage${isMobile ? 'Mobile' : ''}TopHeader`)
    .build();

export const landingPageTopHeader = (isLoggedIn: boolean): TopHeader =>
  new HeaderBuilder()
    .withHeaderBackground('dark')
    .withLefBoxItem('one_logo')
    .withRightBoxItem('lang_menu')
    .withRightBoxItem(isLoggedIn ? 'dashboard_link' : 'login_link')
    .withName(`landingPageTopHeader`)
    .build();

export const supportCenterTopHeader = (isLoggedIn: boolean): TopHeader =>
  new HeaderBuilder()
    .withHeaderBackground('dark')
    .withLefBoxItem('one_logo', { disabled: true })
    .withRightBoxItem('lang_menu')
    .withRightBoxItem(isLoggedIn ? 'dashboard_link' : 'login_link')
    .withName(`supportCenterTopHeader`)
    .build();

export const regFlowTopHeader = (isMobile: boolean): TopHeader =>
  new HeaderBuilder()
    .withHeaderBackground('dark')
    .withLefBoxItem('one_logo')
    .withOptionalRightBoxItem(!isMobile ? 'platform_logos' : undefined)
    .withRightBoxItem('lang_menu')
    .withName(`regFlow${isMobile ? 'Mobile' : ''}TopHeader`)
    .build();

export const onboardingTopHeader = (isMobile: boolean): TopHeader =>
  new HeaderBuilder()
    .withHeaderBackground('dark')
    .withLefBoxItem('one_logo')
    .withOptionalRightBoxItem(!isMobile ? 'platform_logos' : undefined)
    .withRightBoxItem('lang_menu')
    .withRightBoxItem('login_link')
    .withName(`onboarding${isMobile ? 'Mobile' : ''}TopHeader`)
    .build();

export const claimCompanyTopHeader = (isMobile: boolean): TopHeader =>
  new HeaderBuilder()
    .withHeaderBackground('dark')
    .withLefBoxItem('one_logo')
    .withOptionalRightBoxItem(!isMobile ? 'platform_logos' : undefined)
    .withOptionalRightBoxItem(!isMobile ? 'lang_menu' : undefined)
    .withRightBoxItem('user_menu')
    .withName(`claimCompany${isMobile ? 'Mobile' : ''}TopHeader`)
    .build();

export const withBackButtonTopHeader = (isMobile: boolean): TopHeader =>
  new HeaderBuilder()
    .withHeaderBackground('dark')
    .withLefBoxItem('go_back')
    .withOptionalRightBoxItem(!isMobile ? 'lang_menu' : undefined)
    .withRightBoxItem('user_menu')
    .withName(`withBackButton${isMobile ? 'Mobile' : ''}TopHeader`)
    .build();

export const summaryTopHeader = (isMobile: boolean): TopHeader =>
  new HeaderBuilder()
    .withHeaderBackground('dark')
    .withOptionalRightBoxItem(!isMobile ? 'lang_menu' : undefined)
    .withRightBoxItem('user_menu')
    .withName(`summary${isMobile ? 'Mobile' : ''}TopHeader`)
    .build();
